import type { AsyncComponentLoader } from "vue";
import { StrapiSpecialOrdersType } from "~/types/strapi";

export const SPECIAL_ORDER_FORM_PORTAL_CONFIG: Partial<
  Record<StrapiSpecialOrdersType, AsyncComponentLoader>
> = {
  [StrapiSpecialOrdersType.tapes]: () =>
    import(`../components/SpecialOrderForm/Tapes/index.vue`),
  [StrapiSpecialOrdersType.boxes]: () =>
    import(`../components/SpecialOrderForm/Boxes/index.vue`),
  [StrapiSpecialOrdersType.corrugatedBoxes]: () =>
    import(`../components/SpecialOrderForm/CorrugatedCartonBoxes/index.vue`),
  [StrapiSpecialOrdersType.multiLayerBags]: () =>
    import(`../components/SpecialOrderForm/MultilayerBags/index.vue`),
  [StrapiSpecialOrdersType.plasticBagsForPackaging]: () =>
    import(`../components/SpecialOrderForm/PlasticBagsForPackaging/index.vue`),
  [StrapiSpecialOrdersType.plasticBagsWithHandles]: () =>
    import(`../components/SpecialOrderForm/PlasticBagsWithHandles/index.vue`),
  [StrapiSpecialOrdersType.filmTapes]: () =>
    import(`../components/SpecialOrderForm/FilmRibbons/index.vue`),
  [StrapiSpecialOrdersType.labels]: () =>
    import(`../components/SpecialOrderForm/Labels/index.vue`),
  [StrapiSpecialOrdersType.bagsOfDifferentMaterials]: () =>
    import(`../components/SpecialOrderForm/BagsOfDifferentMaterials/index.vue`),
  [StrapiSpecialOrdersType.otherSpecialOrders]: () =>
    import(`../components/SpecialOrderForm/OtherSpecialOrders/index.vue`),
  [StrapiSpecialOrdersType.paperBagsWithHandles]: () =>
    import(`../components/SpecialOrderForm/PaperBagsWithHandles/index.vue`),
  [StrapiSpecialOrdersType.plasticDishes]: () =>
    import(`../components/SpecialOrderForm/PlasticDishes/index.vue`),
  [StrapiSpecialOrdersType.packagingPaperBags]: () =>
    import(`../components/SpecialOrderForm/PaperBagsForPackaging/index.vue`),
};
